import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CamelCaseToHyphen } from '../../../../utils/TextFormatter';
import { GetSearchParams, mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TabButton({ title, name, active, onClick }) {
    return (
        <button
            type="button"
            onClick={() => onClick(CamelCaseToHyphen(name?.toLowerCase()))}
            className={cn(
                `group min-w-20 h-full flex justify-center items-center gap-2.5 bg-transparent text-secondary hover:bg-secondary hover:text-white font-medium text-xl focus:outline-none outline-none transition-colors cursor-pointer rounded-md px-3 py-2`,
                {
                    'active bg-secondary text-white': active
                }
            )}
        >
            <span className="inline-block capitalize">{title || name}</span>
        </button>
    );
}

function AdminInfoTabs({ data }) {
    const navigate = useNavigate();
    const { id } = data;
    const [activeTab, setActiveTab] = useState(GetSearchParams('tab') || 'permissions');

    const handleSetTab = (tab) => {
        setActiveTab(tab);
        navigate(
            mkRelativeUrl(`/settings/admins/${id}/info/`, {
                tab
            })
        );
    };

    return (
        <div className="flex justify-start items-center gap-2 title text-xl font-medium text-primary mb-4 ml-[1px]">
            <div className="flex flex-row gap-2 flex-1 items-center justify-between">
                <span
                    className={cn(
                        'h-13 p-[5px] flex justify-start items-center gap-[5px] bg-secondary-100 rounded-10',
                        {
                            'placeholder-mode': data?.demo
                        }
                    )}
                >
                    <TabButton
                        name="permissions"
                        onClick={handleSetTab}
                        active={activeTab === 'permissions'}
                    />
                </span>
            </div>
        </div>
    );
}

export default AdminInfoTabs;
